export default "__VITE_ASSET__DHwU_4tb__"